import { render, staticRenderFns } from "./zonelist.vue?vue&type=template&id=2ec8dd1e&scoped=true&"
import script from "./zonelist.vue?vue&type=script&lang=js&"
export * from "./zonelist.vue?vue&type=script&lang=js&"
import style0 from "./zonelist.vue?vue&type=style&index=0&id=2ec8dd1e&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8dd1e",
  null
  
)

export default component.exports